// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__8_jOB","calendarButtons":"ClockData_calendarButtons__1ZZAd"};